/* tslint:disable */
const en = {
	login: 'Login',
	register: 'Register',
	emailAndUserName: 'Email/UserName',
	passForgot: 'Forgot Password?',
	usePasswordRecovery: 'Use password recovery',
	verificationSuccessMsg: 'Verification Done Successfully.',
	verificationFailedMsg: 'Oops! Try Again After Sometime.',
	registration: 'Registration',
	registerConfirmationMessage: `By registering for our services, you agree to Stippz's general`,
	termsOfUse: 'Terms and Conditions',
	andThe: 'and',
	privacyPolicy: 'Privacy Policy',
	alreadyAccount: 'Already have an account?',
	noAccount: `Don't have an account?`,
	copyShareLink: 'Copy and share the link with your friends!',
	sizeOfContest: 'Size of Contest',
	close: 'Close',
	copyLink: 'Copy Link',
	pointSystem: 'Select Mode',
	entryFee: 'Entry Fee',
	prizeStructure: 'Prize Structure',
	multiEntry: 'Multientry',
	multipleEntries: 'Multiple Entries',
	contestName: 'Contest Name',
	visibility: 'Visibility',
	private: 'Private',
	public: 'Public',
	next: 'Next',
	back: 'Back',
	confirmAndCreate: 'Confirm & Create',
	chooseGames: 'Choose Games',
	selectAllGame: 'Select all games',
	chooseLeague: 'Choose league',
	settings: 'Settings',
	contestSize: 'Contest Size',
	chooseContestSize: 'Choose contest size',
	chooseNumberOfWinners: 'Choose number of winners',
	chooseEntryFee: 'Choose entry fee',
	numberOfEntries: 'Enter number of entries',
	beginner: 'Beginner',
	beginnerDetails: 'New to Stippz? Compete with Players of the same experience level',
	tournament: 'Tournament',
	tournaments: 'Tournaments',
	tournamentDetails: 'High-Paying contests with guaranteed prize pools',
	h2h: 'Head To Head',
	h2hDetails: 'Compete against a single opponent. Winner takes all',
	multipliers: 'Multipliers',
	multipliersDetails: 'Double your money or play for more',
	fiftyFiftyDetails: 'Finish in the top half to win',
	createContest: 'Create Contest',
	sport: 'Sport',
	league: 'League',
	style: 'style',
	mode: 'Mode',
	rules: 'Rules',
	ruleWinnerPick:
		'confidence contests participants need to assign appoint value to each of their selections in addition to picking the winner of each game.',
	ruleMaxPoint:
		'Starting with one point for the game you are at least sure about, all the way up to the maximum points for the winner pick you want to be worth the most (maximum points depending on the chosen number of games).',
	ruleOnce: 'Each number between 1 and maximum point must be used once only.',
	ruleRemember: 'Remember: the higher number, the more points you will get for being correct.',
	scoring: 'Scoring',
	highestValue: 'Highest Value',
	lowestValue: 'Lowest Value',
	confidenceValue: 'Confidence Value',
	games: 'Games',
	entries: 'Entries',
	winZone: 'Win Zone',
	rulesAndScoring: 'Rules & Scoring',
	lobby: 'Lobby',
	inviteFriends: 'Invite Friends',
	language: 'Language',
	logout: 'Logout',
	plays: 'Plays',
	contests: 'Contests',
	wins: 'wins',
	winRate: 'Winrate',
	profit: 'Profit',
	uploadNewPhoto: 'Upload new photo',
	getVerification: 'Get Verification',
	verificationMsg: 'Verificate your account to get access to full service functionality',
	verificate: 'Verificate',
	save: 'Save',
	changePassword: 'Change Password',
	userName: 'Username',
	firstName: 'First name',
	lastName: 'Last name',
	country: 'Country',
	dob: 'Date of birth',
	oldPassword: 'Old password',
	newPassword: 'New password',
	confirmNewPassword: 'Confirm new password',
	email: 'Email',
	password: 'Password',
	cancel: 'Cancel',
	inviteFriendsSubTitle: 'Invite friends and receive both',
	inviteYourFriends: 'INVITE YOUR FRIENDS',
	shareInvitationLink: 'Share your invitation link e.g. via email, WhatsApp, X or Facebook',
	friendRegister: 'YOUR FRIENDS REGISTER AND PAY IN',
	friendRegisterAndDeposit:
		'Your friends register and deposit at least 5. Make sure they are using your invite link.',
	challengeFriend: 'CHALLENGE YOUR FRIENDS',
	takePart: 'Take part in public or private contests',
	inviteFriendsNow: 'Invite Friends Now',
	contestType: 'Contest type',
	sportsAndLeagues: 'Sports & Leagues',
	byDate: 'By date',
	byName: 'By name',
	clear: 'Clear',
	searchContest: 'Search contest',
	noData: 'No data found.',
	fromToToDate: 'Date from - Date to',
	join: 'Join',
	update: 'Update',
	noContest: 'You have no contests',
	arenaNoContest: 'Currently, there are no contests available.',
	createFirstContest: 'Join a contest in the Arena or create your first contest',
	arenaCreateFirstContest:
		'Don’t worry, new ones are coming soon! Check back later or create your own contest to get started!',
	filterResults: 'Filter results',
	clearAll: 'Clear all',
	upcoming: 'Upcoming',
	live: 'Live',
	history: 'History',
	myProfile: 'My Profile',
	contactUs: 'Contact Us',
	faq: 'FAQ',
	howToPlay: 'How To Play',
	switchToGerman: 'German',
	switchToEnglish: 'English',
	balance: 'BALANCE',
	deposit: 'Deposit',
	nextContestStarts: 'Next Contest Starts',
	withdraw: 'Withdraw',
	Sport: 'Sport',
	Leagues: 'Leagues',
	Style: 'Style',
	Modes: 'Modes',
	Details: 'Details',
	Confirm: 'Confirm',
	standings: 'Standings',
	Prizes: 'Prizes',
	guaranteedPrize: 'Guaranteed Prize',
	odds: 'Risk Reward',
	Classic: 'Classic',
	contestants: 'contestants',
	points: 'Points',
	rank: 'rank',
	prize: 'prize',
	players: 'players',
	entrants: 'entrants',
	Tips: 'Tipps',
	myContests: 'My Contests',
	sort: 'Sort',
	nextContestStart: 'Next Contest Start',
	myAccount: 'My Account',
	contactDetails: 'Contact Details',
	Edit: 'Edit',
	emailNotifications: 'E-Mail Notifications',
	gameDayUpdates: 'GameDay Updates',
	stippzPromotions: 'Stippz Promotions',
	saveChanges: 'Save Changes',
	FAILED: 'Failed',
	COMPLETED: 'Completed',
	OPEN: 'Open',
	Contest_Cancelled_Refund: 'Contest_Cancelled_Refund',
	verificationMethod: 'Verification Method',
	select: 'Select',
	transactionHistory: 'Transaction History',
	soccer: 'Soccer',
	basketball: 'Basketball',
	americanFootball: 'Football',
	hockey: 'Hockey',
	baseball: 'Baseball',
	full: 'full',
	Entry: 'Entry',
	playerProtection: 'Player Protection',
	selfExclusion: 'Self Exclusion',
	Unlimited: 'Unlimited',
	Send: 'Send',
	Submit: 'Submit',
	termOfUse: 'Terms & Conditions',
	privacy: 'Privacy',
	Mo: 'Mo',
	Tu: 'Tu',
	We: 'We',
	Th: 'Th',
	Fr: 'Fr',
	Sa: 'Sa',
	Su: 'Su',
	instantBankTransfer: 'Instant bank transfer',
	bankTransfer: 'Bank transfer',
	imprint: 'Imprint',
	countryOfBirth: 'Country Of Birth',
	address: 'address',
	postCode: 'Post Code',
	Street: 'Street',
	City: 'City',
	Nationality: 'Nationality',
	nameAtBirth: 'Name At Birth',
	cityOfBirth: 'City Of Birth',
	verified: 'Account has been verified',
	notRegister: 'Not Registered?',
	statusInfo:
		'Contest start when contest is at least 70% field. Each additional entry increases guaranteed prizepool',
	prizePool: 'Winning amount which will completely be paid out to players',
	entryFeeInfo: 'will be deduct from your credit',
	multiEntryInfo: 'Number of possible entries for a contest . Depending upon contest size multi entries are possible',
	statusText: 'Status Bar',
	minimumAmount: 'Minimum Amount:10',
	myWinnings: 'My Winnings',
	Required: 'Required',
	requiredFieldValidation: '{{field}} is required!',
	countryR: 'country',
	date: 'Date',
	passwordValidation:
		'Password must contain at least 8 characters, including one uppercase letter, one lowercase letter and one number and one special character and must not contain white space',
	minValueValidation: '{{field}} must be greater than or equal to {{value}}!',
	maxValueValidation: '{{field}} must be less than or equal to {{value}}!',
	noSpaceValidation: 'No space allowed',
	onlyNumbersValidation: 'Only numbers allowed',
	notValid: 'Not Valid',
	onlyNumbersWithNotAllowedZeroAtFirstPosition: 'Only numbers allowed with minimum 5 euro',
	manualDeposit:
		'Deposit money into your Stippz account by bank transfer . The minimum deposit amount is 5 EURO. Your money will usually be credited to your Stippz account within two bank working days . Please use the information same as provided below',
	topUp: 'Top up your account',
	recipient: 'Recipient',
	paymentPurpose: 'Payment of purpose',
	none: 'NONE',
	savedBank: 'Saved Bank Details',
	addNew: 'Add new',
	noSavedAccount: 'No saved bank accounts',
	lobbyDate: 'Date',
	lobbyPrize: ' Prize',
	processingTime: 'Processing time: instant',
	Message: 'Message',
	'amount must be a `number` type, but the final value was: `NaN` (cast from the value `"5scsdc"`).':
		'amount must be a `number` type, but the final value was: `NaN` (cast from the value `"5scsdc"`).',
	verificationSuccess:
		'After successful verification you can withdraw money from your account. Go to account verification.',
	contactUsSubmit: 'Form submitted successfully',
	oldPasswordMatch: 'Does not match with above PassWord',
	confirmPassword: 'Confirm password',
	payOutFee: ' Handling fee per payout:2.50',
	minimumAmount5: 'Minimum amount is 5.00€',
	declined: 'Your verification has been declined. Further review needed. Please contact support@stippz.com',
	needsReview: 'Account needs further review. Please contact support@stippz.com.',
	confirm: 'Confirm',
	publicContest: 'public : contest will be posted in lobby and anyone can join',
	privateContest: 'private : contest will not be posted in lobby. Contest can only be joined by invitation link.',
	setting: 'Setting',
	menu: 'Menu',
	withdrawLimit: 'Payout not possible. The desired payout amount exceeds your current balance!',
	notEnoughMatches:
		'Not enough matches available. Please Go back and choose mixed league for all games . You can create contests always on Monday and Thursday.',
	newEntry: 'Enter new',
	existingEntry: 'Enter with existing',
	minimumUserNameValidation: 'minimumUserNameValidation',
	verificationDone: 'Verification done successfully',
	verificationFailed: 'Oops! try again after sometime',
	returnLogin: 'Return to Login',
	makeYourPicks: 'Make your picks',
	chooseConfidencePoints: 'Choose confidence points',
	pts: 'pts',
	place: 'Place',
	guaranteed: 'Guaranteed',
	invitationCompetition: 'Invitation to the Contest',
	competitionName: 'Contest Name',
	finished: 'Finished',
	myPrize: 'My prize',
	copied: 'Copied',
	prizePoolTitle: 'Prize Pool',
	forFee: 'FREE',
	free: 'Free',
	position: 'Position',
	copyClipboard: 'Link copied to clipboard',
	failCopy: 'Failed to copy link',
	pleaseWait: 'Please Wait...',
	yourBalance: 'Your balance',
	amount: 'Amount',
	id: 'ID',
	liveRank: 'Live Rank',
	livePrize: 'Live Prize',
	iBan: 'IBAN',
	sendEmail: 'Send an email to',
	emailDetails:
		'with a screenshot of your online transfer or a scan of your transfer receipt and your balance will be topped up immediately. Share Please let us know your username in the subject line for clear identification!',
	done: 'Done',
	inProgress: 'In Progress',
	passWordMustMatch: 'Passwords must match',
	lowercaseValidation: '{{field}} must be a lowercase string!',
	trimValidation: '{{field}} must not contain white space in starting/end!',
	customEmailValidation: 'Please provide valid email',
	customPasswordMessageValidation:
		'Password must contain 1 Small, 1 Upper character,1 special character and 1 number, and min length should be 8!',
	minLengthValidation: '{{field}} has to be longer than {{length}} characters!',
	maxLengthValidation: '{{field}} has to be shorter than {{length}} characters!',
	ownerName: 'Account holder',
	bankName: 'Bank Name',
	finishedGames: 'Finished games',
	yourPicks: 'Your picks',
	noGames: 'In this league, there are currently no games available.',
	started: 'Started',
	youCanCreateFirstContest: 'You can create your first contest',
	arena: 'Arena',
	joined: 'Joined',
	guaranteedPrizepool: 'Guaranteed Prizepool',
	prizeMoney: 'Prize money',
	WELCOME_BONUS: 'WELCOME_BONUS',
	REFERENCE_BONUS: 'REFERENCE_BONUS',
	REFERRAL_BONUS: 'REFERRAL_BONUS',
	DEPOSIT_FAIL: 'DEPOSIT_FAIL',
	CONTEST_COMMISSION_BOOKED: 'CONTEST_COMMISSION_BOOKED',
	fiftyFifty: '50/50s',
	chooseMode: 'Select Mode',
	chooseType: 'Choose type',
	allSports: 'All sports',
	passwordRecoveryMessage: 'We will send you a link for recovering your password',
	passwordRecovery: 'Password Recovery',
	checkEmail: 'Check Email',
	sendRecoveryLinkMessage: 'We send you recover link to',
	enterNewPassword: 'Enter new password',
	sendRecoveryLink: 'Send recovery link',
	winnerTakesItAll: 'Winner takes all',
	top2Win: 'Top 2 Win',
	top3Win: 'Top 3 Win',
	top5Win: 'Top 5 Win',
	top10Win: 'Top 10 Win',
	top15Win: 'Top 15 Win',
	top20Win: 'Top 20 Win',
	top25Win: 'Top 25 Win',
	top30Win: 'Top 30 Win',
	top40Win: 'Top 40 Win',
	top50Win: 'Top 50 Win',
	top60Win: 'Top 60 Win',
	top75Win: 'Top 75 Win',
	top100Win: 'Top 100 Win',
	top150Win: 'Top 150 Win',
	top200Win: 'Top 200 Win',
	top300Win: 'Top 300 Win',
	top400Win: 'Top 400 Win',
	top800Win: 'Top 800 Win',
	top1200Win: 'Top 1200 Win',
	top1600Win: 'Top 1600 Win',
	top2000Win: 'Top 2000 Win',
	top2500Win: 'Top 2500 Win',
	top3000Win: 'Top 3000 Win',
	top3300Win: 'Top 3300 Win',
	top4000Win: 'Top 4000 Win',
	top5000Win: 'Top 5000 Win',
	top6000Win: 'Top 6000 Win',
	draw: 'Draw',
	chooseSport: 'Choose sport',
	welcomeBonus: 'Welcome Bonus',
	referenceBonus: 'Reference Bonus',
	referralBonus: 'Referral Bonus',
	depositFail: 'Deposit Fail',
	payout: 'Payout',
	contestJoinCharge: 'Join',
	contestCancelledRefund: 'Refund',
	contestWinAmount: 'Win',
	contestCommissionBooked: 'Contest Commission Booked',
	signUpEmailMsg:
		'The registration process has been successfully completed. We have sent you an email containing an account activation link. Please click on the link to activate your account.',
	joiningMsg: 'Thanks for Joining!',
	wlsignUpEmailMsg: 'Explore the contest by logging into the platform and making the most of your experience!',
	halfTime: 'Halftime',
	fullTime: 'Finished',
	ibanValidation: 'IBAN format (22 digits): DE + 20 digits.',
	amountValidation: 'Please enter a valid number.',
	error404: 'Error 404',
	message404:
		'Sorry, the page you requested could not be found. It may have been moved or deleted. Please check the URL and try again.',
	homeButtonText: 'Go to the home page',
	error503: 'Error 503',
	message503:
		"We're sorry, but the server is currently unavailable and not ready to handle the request. Please try again later.",
	contestSearchErrorMsg: 'Contest name must be longer than or equal to 3 characters',
	withDrawNote: 'Note : You can only withdraw the whole amount.',
	contest1: '"The more difficult the victory,',
	contest1_1: 'the greater the happiness in winning."',
	contest1_2: '',
	contest1_writer: 'Pelé',
	contest2: `"I spent my life trying not to be arrogant.`,
	contest2_1: `But when you're the best,`,
	contest2_2: 'you start telling it."',
	contest2_writer: 'Zlatan Ibrahimovic',
	contest3: `"If you don't believe you can win,`,
	contest3_1: `there is no point in getting out of bed."`,
	contest3_2: '',
	contest3_writer: 'Neville Southall',
	contest4: '“The first 90 minutes',
	contest4_1: 'are the most important.”',
	contest4_2: '',
	contest4_writer: 'Bobby Robson',
	contest5: '“If you do not believe you can do it,',
	contest5_1: 'then you have no chance at all.”',
	contest5_writer: 'Arsene Wenger',
	contest7_1: 'Bundesliga Contest',
	contest7_2: '350€ Prize pool',
	contest7_3: 'Participation until 14.04.2024',
	contest7_4: '150 players',
	contest8: 'New contests',
	contest8_1: 'Every day',
	contest9: 'We love the sport,',
	contest9_1: 'we love the game!',
	contest10: 'Playing is',
	contest10_1: 'the real kick!',
	contest11: 'Be part of the game',
	contest12: "It's not just a game, it's a contest",
	contest12_1: "it's a contest",
	contest13: 'STIPPZ takes',
	contest13_1: 'your football experience',
	contest13_2: 'to the next level',
	joinedStatusTag: 'Joined',
	cancelled: 'Cancelled',
	filters: 'Filters',
	filter: 'Filter',
	walletHistory: 'History',
	registrationPolicy: 'and certify that you are 18 years old or older.',
	of: 'of',
	seireATitle_1: 'Live Italian',
	seireATitle_2: 'emotions every',
	seireATitle_3: 'weekend',
	serieASubTitle_1: 'Win great cash prizes -',
	serieASubTitle_2: 'take part now for free!',
	bundesLigaTitle_1: 'Pure excitement',
	bundesLigaTitle_2: 'in the Bundesliga',
	bundesLigaTitle_3: 'Contests',
	bundesLigaSubTitle_1: 'Cash prizes',
	bundesLigaSubTitle_2: 'every weekend!',
	laLigaTitle_1: 'Experience the temperament',
	laLigaTitle_2: 'of La Liga',
	laLigaTitle_3: 'every weekend',
	laLigaSubTitle_1: 'Take part in contests for free',
	laLigaSubTitle_2: 'and win prize money!',
	mixedTitle_1: 'Top European football',
	mixedTitle_2: 'with cash prizes',
	mixedTitle_3: 'every weekend',
	mixedSubTitle_1: 'Playing is',
	mixedSubTitle_2: 'great fun!',
	premierTitle_1: 'Feel the excitement',
	premierTitle_2: 'of the Premier League',
	premierTitle_3: 'Contests',
	premierSubTitle_1: 'Play now and win',
	premierSubTitle_2: 'prize money - every weekend!',
	week: 'Week',
	iOSInstall: 'Add stippz to Home Screen in order to use Web App view!',
	verificationMessage: 'You can participate and play for free immediately after signing in',
	continue: 'Continue',
	uefaEuropeanTitle_1: 'Bet on the best',
	uefaEuropeanTitle_2: 'of the best and',
	uefaEuropeanSubTitle_1: 'win big in the Champions League contests.',
	uefaEuropeanSubTitle_2: 'Play for free and cash in.',
	statistics: 'Statistics',
	discord: 'Discord',
	minContestantRequired: 'This contest will start only when at least {minContestantRequired} player have joined!',
	boostInfo: 'wins with 2 or more goals',
	win: '',
	winsOrDraw: 'wins or draw',
	winsWith: 'wins by',
	goals: 'goals',
	rewards: 'Rewards',
	withDrawHistory: 'WithDraw History',
	winsBy: 'wins by',
	goalsDifference: 'goals or more',
	winsOrLosesByMax: 'wins or loses by max',
	pointDifference: 'points or more',
	news: 'NEWS',
	fanshop: 'FANSHOP',
	tickets: 'TICKETS',
	riskRewardMode: 'Risk Reward mode',
	inRiskReward: 'In the "Risk Reward" game mode, you choose between five possible bets:',
	boostHomeWinDrawAwayWin: 'Boost, Home Win, Draw, Away Win, ',
	boostHomeWinAwayWin: 'Boost, Home Win, Away Win, ',
	and: 'and',
	pointsRule:
		'You earn points for each correct bet, with the points varying depending on your choice. Your total score determines your ranking in the contest.',
	boost: 'Boost',
	safety: 'Safety',
	boostRule: '🚀 can only be placed on the favorite in a matchup.',
	footBallBoostRule: 'The favorite must win by at least two goals.',
	basketBallBoostRule:
		'The favorite must win by a predetermined point difference (ranging from 2 to 12 points, depending on the matchup).',

	safetyRule: '🛡️ is exclusively available for the underdog.',
	footBallSafetyRule: 'The underdog must win or secure a draw.',
	basketBallSafetyRule:
		'The underdog must win or lose by no more than the predetermined point difference (ranging from 1 to 11 points, depending on the matchup).',
	note: 'Note',
	pointsPublication:
		'The points for the matchups are usually published no later than 1 to 2 days before the start of the contest. However, occasional delays may occur. In such cases, the affected matchups will remain locked and cannot be predicted until the points are released. To ensure everything is up-to-date, it is recommended to review your picks and fill in any missing entries at least one day before the contest begins.',
	savePicksReminder: 'You can save your picks at any time and continue later.',
	rulesForBoostAndSafety: 'Rules for Boost and Safety',
	strategicAdjust:
		'You can strategically adjust your bets for remaining games to gain an advantage at the last moment—whether by extending your lead or overtaking other players.',
	picksChangeInfo:
		'Picks can be chnaged up to 1 minute before the start of a game. Once a game has started, changes are no longer possible.',
	planBets:
		'Plan your bets wisely and take advantage of the special rules for Boost and Safety to stay ahead in the contests!',
	tieRules: 'In the event of a tie',
	tieRulesDescription:
		'If two or more participants achieve the same score in a prize contest, the winner is determined by the timestamp of their participation. Priority is given to the participant who clicked "Join" first. The timing is measured accurately to the millisecond.',
	contestResultMessage:
		'Too bad, you didn’t make it into the winning zone so far. But don’t worry—Give it another shot in the next contest!',
	contestWinZoneResultMessage:
		'Unfortunately, you didn‘t make it into the winning zone this time. Give it another shot in the next contest!',
	tipOff: 'Tip-Off',
	whiteLabelIOSInstall: 'Add EBO to Home Screen in order to use Web App view!',
	oddsNotAvailable: 'Points will be available soon. Check out later again.',
	wlNoContest: 'Currently, no contests are available.',
	wlJoinContest: 'But don’t worry, more will be coming soon. Check back later!',
	sideBarWins: 'wins',
	gotIt: 'Got it!',
	contestFull: 'The contest is full.',
	joinAnotherContest: 'Please try join another contest!',
	goToHome: 'Go to Home',
	viewUpdates: 'View Updates',
	versionUpgrade: 'Version Upgrade',
	updateAvailableMsg: 'New updates available!',
	refreshMsg: 'Click the button below to explore the latest changes.'
};

export default en;
